export const styles = {
  profileContainer: {
    display: 'flex',
    height: '19px',
    width: '19px',
    position: 'absolute',
    bottom: '6px',
    left: '6px',
  },

  profile: {
    width: '19px',
    height: '19px',
    borderRadius: '8px',
  },

  container: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    gap: '8px',
  },

  typo: {
    fontFamily: 'Inter',
    fontWeight: '500',
    lineHeight: '150%',
    fontSize: '12px',
    color: '#8c8f9d',
  },

  itemsContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    gap: '4px',
    flexWrap: 'wrap',
  },

  imageContainer: {
    width: 'calc((100% - 8px) / 3)',
    position: 'relative',
    borderRadius: '12px',
    cursor: 'pointer',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
};
